<dashboardnav>
  <div class="reference_body">
    <main class="reference_main">
      <div class="pink_box"></div>
      <div class="green_box"></div>
    <div *ngIf="
    !(isLoadingCountry$ | async) &&
    !(isLoadingState$ | async) &&
    !(isLoadingLga$ | async) &&
    !(isLoadingCommunity$ | async) &&
    !(isLoadingActionParty$ | async) &&
    !(isLoadingCompany$ | async) &&
    !(isLoadingFunction$ | async) &&
    !(isLoadingRequestCategory$ | async) &&
    !(isLoadingIssuedCategory$ | async) &&
    !(isLoadingTeam$ | async) &&
    !(isLoadingCurrency$ | async)
    " >

  <div class="container">
  <div class="row">
    <div class="col-sm-3 mt-4 ml-5">
  <mat-form-field class="full-width-field">
      <mat-label>Select Project Reference Form</mat-label>
      <mat-select
      (selectionChange)="selectReference($event)" >
        <mat-option>None</mat-option>
        <mat-option class="option" *ngFor="let item of items" [value]="item.id"
          >{{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    </div>
  </div>
  </div>
  </div>
    <div [ngSwitch]="task">
      <ng-template ngSwitchCase="reference">
        <mrsoftapps-correspondence-form-container
          [countries]="country$ | async"
          [states]="state$ | async"
          [lgas]="lga$ | async"
          [actionParties]="actionParty$ | async"
          [functions]="function$ | async"
          [companies]="company$ | async"
          [requestCategories]="requestCategory$ | async"
          [communities]="community$ | async"
          [issuedCategories]="issuedCategory$ | async"
          [teams]="team$ | async"
          [currencies]="currency$ | async"
          [data]="data"
          (changeEmit)="onSubmitProjectRef($event)"
          (deleteEvent)="onDelete($event)"
          *ngIf="
          !(isLoadingCountry$ | async) &&
          !(isLoadingState$ | async) &&
          !(isLoadingLga$ | async) &&
          !(isLoadingCommunity$ | async) &&
          !(isLoadingActionParty$ | async) &&
          !(isLoadingCompany$ | async) &&
          !(isLoadingFunction$ | async) &&
          !(isLoadingRequestCategory$ | async) &&
          !(isLoadingIssuedCategory$ | async) &&
          !(isLoadingTeam$ | async) &&
          !(isLoadingCurrency$ | async)
          "
        >
        </mrsoftapps-correspondence-form-container>
      </ng-template>
    </div>
    <mrsoftapps-epims-reference-spinner *ngIf="
    (isLoadingCountry$ | async) ||
    (isLoadingState$ | async) ||
    (isLoadingLga$ | async) ||
    (isLoadingCommunity$ | async) ||
    (isLoadingActionParty$ | async) ||
    (isLoadingCompany$ | async) ||
    (isLoadingFunction$ | async) ||
    (isLoadingRequestCategory$ | async) ||
    (isLoadingIssuedCategory$ | async) ||
    (isLoadingTeam$ | async) ||
    (isLoadingCurrency$ | async)
    ">
    </mrsoftapps-epims-reference-spinner>
    </main>
    </div>
  </dashboardnav>
